import Image from "next/image";
import Link from "next/link";
import router from "next/router";
import { FormEvent } from "react";

import imageLoader from "../../../../utils/loader";
import classes from "./accountMenuCategory.module.scss";

interface Props {
  label: string;
  selected: boolean;
  path: string;
  isImage?: boolean;
  onClick?: () => void;
}

const AccountMenuCategory = ({
  label,
  selected,
  path,
  children,
  isImage = false,
  onClick,
}: React.PropsWithChildren<Props>) => {
  const handleClick = (e: FormEvent, path: string) => {
    e.preventDefault();

    if (onClick) onClick();
    router.push(path);
  };

  return (
    <Link href={onClick ? "" : `${path}`}>
      <a
        onClick={(e) => {
          handleClick(e, path);
        }}
      >
        <div
          className={[classes.button, selected ? classes.selected : ""].join(
            " "
          )}
        >
          {isImage ? (
            <>
              <div className={classes.notActive}>
                <Image
                  loader={imageLoader}
                  src={"salad.svg"}
                  alt={"Salad Icon"}
                  width={20}
                  height={20}
                />
              </div>
              <div className={classes.active}>
                <Image
                  loader={imageLoader}
                  src={"salad-green.svg"}
                  alt={"Selected Salad Icon"}
                  width={20}
                  height={20}
                />
              </div>
            </>
          ) : (
            <div className={classes.icon}>{children}</div>
          )}

          <div>
            <span className={classes.label}>{label}</span>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default AccountMenuCategory;
